import log from "loglevel";

import { PresenceVisitor } from "../../../types/Glance";
import { glanceConnected, glanceError } from "../genericActions";
import { AppDispatch } from "../../definitions";
import { updateSyncMapItemIsCoBrowserEnabled } from "../syncActions";

export const initGlanceListeners = (glanceVisitor: PresenceVisitor | undefined, dispatch: AppDispatch) => {
    if (!glanceVisitor) {
        return;
    }

    // When there is an error
    glanceVisitor.onerror = (error) => {
        log.warn(`GlanceListeners: glanceVisitor error %o`, error);
        dispatch(glanceError(error));
    };

    // When the agent signals the client
    glanceVisitor.onsignal = (msg) => {
        log.info(`GlanceListeners: glancevisitor on signal %o`, msg);
    };

    // This is going to be triggered on the connection is achieved
    glanceVisitor.onconnected = () => {
        log.info(`GlanceListeners: Glance visitor connected, dispatching`);
        dispatch(glanceConnected());
    };

    window.GLANCE.Cobrowse.Visitor.addEventListener("sessionstart", () => {
        log.info(`GlanceListeners: Visitor has accepted and joined the Glance cobrowse session`);
        dispatch(updateSyncMapItemIsCoBrowserEnabled(true));
    });
};
